import VueRouter from 'vue-router'
import auth from '../auth'
import store from './store'

const baseRouter = new VueRouter({
  mode: 'history',
})

baseRouter.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    auth.getUser().then(user => {
      if (!!user && !user.expired) {
        store.commit('context/setLogedInUser', user)
      }
    })
    if (process.env.NODE_ENV === 'development') {
      console.log(`No authentication required. We can navigate: '${to.path}'`)
    }
    next()
  } else {
    auth.getUserRedirect().then(user => {
      store.commit('context/setLogedInUser', user)
      if (process.env.NODE_ENV === 'development') {
        console.log(`Authenticating a protected route: '${to.path}'`)
      }
      next()
    })
  }
})

export default baseRouter
